import i18n from '@/i18n';
import moment from 'moment';
/**
 * 获取差异数组
 * @param parentList: Array
 * @param childrenList: Array
 * @param key: String
 */
export const filterList = (parentList = [], childrenList = [], key = "id") => {
  let arr = [];
  arr = parentList.filter((item) => {
    return childrenList.every((citem) => item[key] !== citem[key]);
  });
  return arr;
};
/**
 * 校验不为空
 * val: value值
 */
export const checkEmpty = (val) => {
  if (!val) return false;
  else return true;
};
/**
 * 校验长度
 * val: value值
 * min: 最小长度（包含）
 * max: 最大长度（包含）
 */
export const checkLength = (val, min = val.length, max = min) => {
  const len = val.length;
  if ((len > min || len === min) && (len < max || len === max)) return true;
  else return false;
};
/**
 * 校验邮箱格式
 * val: value值
 */
export const checkEmail = (val) => {
  const REG = /^[A-Za-z0-9\u4E00-\u9FA5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
  if (REG.test(val)) return true;
  else return false;
};

/**
 * @param list: Array 要遍历的数组
 * @param key: String 要删除的key名
 * @param value: any 要删除的value值
 * @return Array 删除指定value，返回新数组
 */
export const filterValues = (list = [], value = null, key = "") => {
  if (list.length === 0) return list;
  if (!key) {
    list.forEach((item, index) => {
      if (item === value) {
        list.splice(index, 1);
      }
    });
    return list;
  } else {
    list.forEach((item, index) => {
      if (item[key] === value) {
        list.splice(index, 1);
      }
    });
    return list;
  }
};

// 生成uuid
export function getUuid() {
  let d = new Date().getTime();
  const uuid = "xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
}

// 监听浏览器tab关闭、刷新
function removeEventListener(str) {
  document.removeEventListener(str);
}
const beforeunloadFn = function (e) {
  const message = "关闭提示！";
  e = e || window.event;
  if (e) {
    e.returnValue = message;
  }
  return message;
};
export function onBeforeunload() {
  window.addEventListener("beforeunload", beforeunloadFn, false);
}
export function closeBeforeunload() {
  window.removeEventListener("beforeunload", beforeunloadFn, false);
}

// 监听浏览器tab切换
export function onVisibilitychange(callback) {
  document.addEventListener("visibilitychange", () => {
    let type = "";
    if (document.visibilityState === "hidden") {
      // 离开当前tab标签
      type = "leave";
      typeof callback === "function" && callback(type);
      console.log("离开当前tab标签");
    } else {
      type = "back";
      typeof callback === "function" && callback(type);
      console.log("回到当前tab标签");
    }
  });
}
export function closeVisibilitychange() {
  const e = "visibilitychange";
  removeEventListener(e);
}

/**
 * 函数节流
 */
export function throttle(fn, delay) {
  let lastTime;
  let timer;
  delay = delay || 200;
  return function () {
    const args = arguments;
    // 记录当前函数触发的时间
    const nowTime = Date.now();
    if (lastTime && nowTime - lastTime < delay) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        // 记录上一次函数触发的时间
        lastTime = nowTime;
        // 修正this指向问题
        fn.apply(this, args);
      }, delay);
    } else {
      lastTime = nowTime;
      fn.apply(this, args);
    }
  };
}

export const dataTimeFn = (originVal) => {
  if (originVal && originVal != "") {
    var date = new Date();
    // 自动判断秒(10位)还是毫秒(13位)
    let time = Number(originVal);
    if (String(originVal).length < 13) {
        time = time * 1000;
    }
    date.setTime(time);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? "0" + m : m;
    var d = date.getDate();
    d = d < 10 ? "0" + d : d;
    var h = date.getHours();
    h = h < 10 ? "0" + h : h;
    var minute = date.getMinutes();
    var second = date.getSeconds();
    minute = minute < 10 ? "0" + minute : minute;
    second = second < 10 ? "0" + second : second;
    return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
  } else {
    return "";
  }
};

const add0 = (m) => {
  return m < 10 ? "0" + m : m;
};

export const getTime = (shijianchuo) => {
  shijianchuo = parseInt(shijianchuo);
  var time = new Date(shijianchuo);
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  var s = time.getSeconds();
  return y + "-" + add0(m) + "-" + add0(d) + " " + add0(h) + ":" + add0(mm) + ":" + add0(s);
};

export const prefix = (item, key) => {
  if (item.createUserName === "system" && key !== "remindingUserName") {
    return i18n.t('recycle.recycle12');
  }
  if (!item.forwardType) {
    return i18n.t('recycle.recycle10');
  }
  if (key === "createUserName") {
    if (item.forwardType == "0") {
      return i18n.t('recycle.recycle10');
    } else {
      return i18n.t('recycle.recycle11');
    }
  }
  if (key === "remindingUserName") {
    if (item.createUserName === "system") {
      return i18n.t('recycle.recycle10');
    } else {
      if (item.forwardType == "0") {
        return i18n.t('recycle.recycle11');
      } else {
        return i18n.t('recycle.recycle10');
      }
    }
  }
};

export const prefixColor = (item, key) => {
  if (item.createUserName === "system" && key !== "remindingUserName") {
    return "#5baa6c";
  }
  if (!item.forwardType) {
    return "#f56c6c";
  }
  if (key === "createUserName") {
    if (item.forwardType == "0") {
      return "#f56c6c";
    } else {
      return "#f59a23";
    }
  }
  if (key === "remindingUserName") {
    if (item.createUserName === "system") {
      return "#f56c6c";
    }
    if (item.forwardType == "0") {
      return "#f59a23";
    } else {
      return "#f56c6c";
    }
  }
};

// 时间换行处理 - 需要配合 white-space: pre-warp 使用
export function timerLineFeed(val) {
  if (!val) return val;
  if (typeof val === "string" && val.length === 10) {
    const start = moment.unix(val).format("YYYY-MM-DD");
    const end = moment.unix(val).format("HH:mm:ss");
    return start + "\r\n" + end
  }
  const start = moment(val).format("YYYY-MM-DD");
  const end = moment(val).format("HH:mm:ss");
  return start + "\r\n" + end
}

// 千分位格式化
export function formatThousands(number) {
  return Number(number).toLocaleString();
}

// 数字千分位并且保留小数后2位
export function formatMoney(value) {
  const num = Number(value);

  if (Number.isNaN(num)) return '0.00';

  return num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}


/**
 * 数字添加千分位，返回带逗号的字符串
 * @param {number|string} val
 * @param {number} decimals  小数位数，默认4位
 */
export const formatThousand = (val, decimals = 4) => {
  const raw = val == null || val === '' ? '' : String(val).replace(/,/g, '');
  if (raw === '') return '';
  const num = parseFloat(raw);
  if (isNaN(num)) return raw;
  const fixed = num.toFixed(decimals);
  const parts = fixed.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  parts[1] = (parts[1] || '').replace(/0+$/, '');
  return parts[1] ? parts.join('.') : parts[0];
};

/**
 * 移除千分位逗号，返回原始数字字符串
 */
export const unformatThousand = (val) => {
  if (val == null) return '';
  return String(val).replace(/,/g, '');
};

/**
 * 移除数字末尾无效的0，保留最多指定位小数
 * @param {string|number} val
 * @param {number} maxDecimals  最大小数位数
 */
export const stripTrailingZeros = (val) => {
  if (val == null || val === '') return '';
  const raw = String(val).replace(/,/g, '');
  const idx = raw.indexOf('.');
  if (idx === -1) return raw;
  const intPart = raw.slice(0, idx);
  const decPart = raw.slice(idx + 1).replace(/0+$/, '');
  if (!decPart) return intPart || raw;
  return `${intPart}.${decPart}`;
};
